import { mpx } from '@didi/es-mpx-creator'
import { RECIEVE_COUPON, GET_COUPON_LIST } from '@/api/urls'

/**
 * @method 领券
 * @param params
 * @returns {Promise}
 */
export const requestCouponApi = data => {
  return mpx.$http.post(RECIEVE_COUPON, { data })
}

/**
 * @method 获取券列表信息
 * @param params
 * @returns {Promise}
 */
export const getCouponListApi = data => {
  return mpx.$http.post(GET_COUPON_LIST, { data })
}
